<div class="row title">
	<h3>Dashboard / <span>Portfolio Data</span></h3>
	<p class="add" (click)="tooltipHide()" [routerLink]="['/portfolio/create']" routerLinkActive='active'><i class="fa fa-plus"  aria-hidden="true"></i></p> 
	<div style="margin-left: 18%;" class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
	<div class="ss-searchbox" style="margin-top: -2px;">
		<i class="fa fa-search"></i>
		<input class="form-control"  style="background-color: #f7f7f7;" name="search" type="text" placeholder="Type Apartment Name,ID,Segment,Space,Variant ID,Preset Number to search" [(ngModel)]="searchstring" (keydown.enter)="getpage('')">
  </div>
	</div>
</div>
<div class="row body_height justify-content-center">
	<div class="col-12" *ngIf="erroralert">
		<div class="alert-box grid-100" *ngIf="errorMessage">
			<div class="alert alert-danger mt-3 text-center"> <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a> {{errorMessage}} </div>
		</div>
	</div>
	<div class="col-12" *ngIf="successalert">
		<div class="alert-box grid-100" *ngIf="successMessage">
			<div class="alert alert-success mt-3 text-center"> <a class="close link" data-dismiss="alert" (click)="successalert=false">×</a> {{successMessage}} </div>
		</div>
	</div>
	
	<div class="col-12 table-responsive p-0" id="scrollTop">

		<h5 *ngIf="portfolio.length === 0 " class="text-center " style="margin-top:15.5rem"> No portfolios Available</h5>
		<table *ngIf="portfolio.length > 0" class="table table-hover">
			<thead>
				<tr>
					<th class="text-center">ID</th>
					<th class="text-center">Segment</th>
					<th class="text-center">Space</th>
					<th class="text-center">Apartment Name,<br>Format & Variant ID</th>
					<th class="text-center">Price</th>
					<th class="table_img_col text-center">Image</th>
					<th class="table_active_col text-center">Actions</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let data of portfolio |  paginate: { itemsPerPage:10,currentPage: current_page,totalItems: total_page };let i = index" [attr.data-index]="i">
					<td class="text-center">{{data.id}}</td>
					<td class="text-center">{{data.segment}}</td>
					<td class="text-center">{{data.space}}</td>
					<td *ngIf="!data.apartment.length> 0" class="text-center">-</td>
					<td *ngIf="data.apartment.length > 0" >Apartment Name-{{data.apartment[0].apartment_name}}<br>
						Format-{{data.apartment[0].format}}<br>
						Variant ID-{{data.apartment[0].variant_id}}</td>
					<td>{{data.price_cents}}</td>
					<td> <img class="my-2" src="{{data.attachment_file}}" onerror="src='../../../assets/img/default-apartment.png'" width="200px" *ngIf="data.attachment_file !='/images/original/missing.png' "><img src="../../../../assets/v3/img/noimgicon.jpeg" height="240px" width="260px" *ngIf="data.attachment_file =='/images/original/missing.png' "> </td>
					<td class="text-center fa_icons"> <a data-toggle="modal" data-target="#exampleModalLong" (click)="getPortfolio(data.id)"><i data-toggle="tooltip" title="Edit" data-placement="top" class="fa fa-pencil" aria-hidden="true"></i></a> <a (click)="confirmAndDelete(data.id)"><i data-toggle="tooltip" title="Delete" data-placement="top" class="fa fa-trash" aria-hidden="true"></i></a>
						<div class="alert alert-warning my-2" *ngIf="(data.attachment_size/1024) > 120"> <strong>Warning!</strong> Image size exceeds 120kb. </div>
						<!-- <div class="alert alert-danger my-2"  *ngIf="((data.attachment_height != null) || (data.attachment_width != null)) && ((data.attachment_height != 583) || (data.attachment_width != 1010))">
              <strong>Error!</strong> Image resolution doesn't match with the specified resolutions (1010 X 583).
            </div> -->
					</td>
				</tr>
			</tbody>

		</table>
	
		</div>
		<div *ngIf="portfolio.length > 0">
		<pagination-controls  autoHide="true" (pageChange)="current_page = getpage($event)"  previousLabel="PREV"
		nextLabel="NEXT" class="float-right"></pagination-controls>
		</div> 
	
	</div>
	

<div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<form (ngSubmit)="onSubmit(editPortfolioForm.value); editPortfolioForm.reset();" #editPortfolioForm="ngForm">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLongTitle">Update Portfolio Details</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Segment<span class="astric">*</span></label>
								<select class="form-control" name="segment" [(ngModel)]="segment" (change)="firstDropDownChanged($event.target.value)">
									<option value="">Select Segment</option>
									<option value="Home" [selected]="segment == 'Home'">Home</option>
									<option value="Office" [selected]="segment == 'Office'">Office</option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Space<span class="astric">*</span></label>
								<select class="form-control" name="space" [(ngModel)]="space" (change)="spaceDropDownChanged($event.target.value)">
									<option value="">Select Space</option>
									<option *ngFor="let v of spaces" value="{{v}}" [selected]="space == v"> {{v}} </option>
								</select>
							</div>
						</div>
						<div class="col-md-6" *ngIf="segment=='Home' && (space == 'Living' || space == 'Kitchen' || space == 'Kids Room' || 'Master bedroom' || 'Guest Bedroom' || 'Dining Room' || 'All Spaces' )">
							<div class="form-group label-floating">
								<label class="control-label"> Theme<span class="astric">*</span></label>
								<select class="form-control" name="theme" [(ngModel)]="theme">
									<option value="">Select Theme</option>
									<option *ngFor="let v of themes" value="{{v}}" [selected]="theme == v"> {{v}} </option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Lifestage<span class="astric">*</span></label>
								<select class="form-control text-capitalize" name="lifestage" [(ngModel)]="lifestage" (change)="selectLifeStage($event.target.value)">
									<option value="">Select Lifestage</option>
									<option *ngFor="let v of lifestages" value="{{v.name}}" [selected]="lifestage == v.name"> {{transform(v.name)}} </option>
								</select>
							</div>
						</div>
						<div class="col-md-6" *ngIf="segment=='Home' && space == 'Bedroom' ">
							<div class="form-group label-floating">
								<label class="control-label"> Element</label>
								<select class="form-control" name="element" [(ngModel)]="element">
									<option value="">Select Element</option>
									<option *ngFor="let v of elements" value="{{v}}" [selected]="element == v"> {{v}} </option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> EMI<span class="astric">*</span></label>
								<input type="number" class="form-control" name="price_cents" [(ngModel)]="price_cents" min=0> </div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> User Story Title</label>
								<input type="text" class="form-control" name="user_story_title" [(ngModel)]="user_story_title"> </div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Preset Number</label>
								<input type="text" class="form-control" name="preset_number" [(ngModel)]="preset_number"> </div>
						</div>
						<!--Preset Type-->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Preset Type</label>
								<select class="form-control" name="preset_type" [(ngModel)]="preset_type">
									<option value="Basic">Basic</option>
									<option value="Advanced">Advanced</option>
									<option value="Plus">Plus</option>
								</select>
							</div>
						</div>
						<!--Space Area-->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Space Area</label>
								<input type="text" class="form-control" name="space_area" [(ngModel)]="space_area"> </div>
						</div>
						<!--Space Shape-->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Space Shape</label>
								<input type="text" class="form-control" name="space_shape" [(ngModel)]="space_shape"> </div>
						</div>
						<!--City-->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Selected City</label>
								<ng-select placeholder="Search For City" class="" name="city" [(ngModel)]="city" (change)="getscityList($event)" (keyup)="searchCity($event)">
									<ng-option *ngFor="let city of city_list" [value]="city.name">{{ city.name | titlecase }}</ng-option>
								</ng-select>
							</div>
						</div>
            <!--Apartment Name-->
            <!-- <ng-container *ngIf="societyList && societyList.length > 0"> -->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Selected Apartment</label>
								<ng-select class="" name="apartment_name" [(ngModel)]="apartment_name" (change)='getselectedbuilding($event)' (keyup)="searchSociety($event)">
									<ng-option *ngFor="let build of societyList" [value]="build.attributes.unid">{{ build.attributes.apartment_name }}</ng-option>
								</ng-select>
							</div>
            </div>
            <!-- </ng-container> -->
            <!--Select flat-type/size-->
            <!-- <ng-container *ngIf="societyList && societyList.length > 0"> -->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Selected Flat Type/ Size</label>
								<ng-select class="" name="format" [(ngModel)]="format" (change)="getselectedbuildingtypes($event)">
									<ng-option *ngFor="let types of flatsize" [value]="types">{{ types }}</ng-option>
								</ng-select>
							</div>
            </div>
            <!-- </ng-container> -->
            <!--Select Varient-->
            <!-- <ng-container *ngIf="societyList && societyList.length > 0"> -->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label">Selected Variant</label>
								<ng-select class="" name="variant_id" [(ngModel)]="variant_id" (change)="isAllVarient($event)">
									<ng-option *ngFor="let types of varientId" [value]="types.id">{{ types.variant_id }}</ng-option>
					
								</ng-select>
							</div>
            </div>
			
            <!-- </ng-container> -->
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> BOQ Number</label>
								<!-- <input type="text" class="form-control" name="boq_number" [(ngModel)]="boq_number"> -->
								<ng-select placeholder="Search and Select BOQ" class="" name="boq_number" [(ngModel)]="boq_number" (change)="getsBOQnumber($event)" (keyup)="searchBOQ($event)">
									<ng-option *ngFor="let build of boq_dropdown" [value]="build.reference_number">{{ build.reference_number }}</ng-option>
								</ng-select>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> BOQ Value</label>
								<input type="text" class="form-control" disabled name="boq_value" [(ngModel)]="boq_value"> </div>
						</div>
						<div class="col-md-12">
							<div class="form-group label-floating">
								<label class="control-label"> Description</label>
								<textarea class="form-control" name="description" [(ngModel)]="description"></textarea>
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group label-floating">
								<label class="control-label"> Portfolio Data</label>
								<textarea class="form-control" name="portfolio_data" [(ngModel)]="portfolio_data"></textarea>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group label-floating">
								<label class="control-label"> Change Main Image<span class="astric">(Single Image Upload is allowed)*</span></label>
								<input type="file" class="form-control" (change)="onChange($event)" name="attachment_file" ngModel #attachment_file="ngModel"> </div> <img src="{{imgsrc}}" id="updateimgsrc" height="300px" width="100%" *ngIf="imgsrc" /> </div>
						<div class="col-md-12">
							<div class="form-group label-floating">
								<label class="control-label">Change Secondary Images:- <span class="astric">(Multiple Image Upload Allows Max 5 images)</span></label>
								<ng-container *ngFor="let data of secondaryImage; let i=index">
									<!-- <label>Image{{i}}</label> -->
									<a [href]="data.attributes.document" class="ml-4" target="_blank" style="color: #8d0528; text-decoration: none;">Image {{ i+1}}</a>
									<span (click)="deleteContent(data.attributes.id)" style="color: #8d0528; text-decoration: none;">(Delete)</span>
									</ng-container>
									<input type="file" class="form-control" (change)="onChangeSecondary($event)" name="attachment_file_secondary" ngModel #attachment_file_secondaryi="ngModel">
								
								</div>
						</div>		
						<div class="col-md-12 mt-5">
							<div class="form-group label-floating">
								<p>Space item selected:</p>
								<ul class="ks-cboxtags" id="myUL">
									<li *ngFor="let item of space_item;let j = index"> <span>
                              <input type="checkbox" id="{{item.item_name+j}}"
                                 value="{{item.id}}" (change)="isAllSelected($event,j)" checked>
                              <label class="text-capitalize" for="{{item.item_name+j}}">{{item.item_name}}</label>
                            </span>
										<!-- <span *ngIf="!leadItemscheckedListNames.includes(item.name.toLowerCase())">
                              <input type="checkbox" id="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}"
                                (change)="isAllSelected($event)" value="{{item.name}}">
                              <label for="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}">{{item.name}}</label>
                            </span> --></li>
								</ul>
								<ul class="ks-cboxtags" id="myUL">
									<li *ngFor="let item of other_space_item;let j = index"> <span>
                                    <input type="checkbox" id="{{item.item_name+j}}"
                                       value="{{item.id}}" (change)="isAllSelected($event,j)">
                                    <label class="text-capitalize" for="{{item.item_name+j}}">{{item.item_name}}</label>
                                  </span>
										<!-- <span *ngIf="!leadItemscheckedListNames.includes(item.name.toLowerCase())">
                                    <input type="checkbox" id="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}"
                                      (change)="isAllSelected($event)" value="{{item.name}}">
                                    <label for="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}">{{item.name}}</label>
                                  </span> --></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
					<button type="submit" class="button button_emi">Update</button>
				</div>
			</form>
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/portfolio/listportfoliodata/listportfoliodata.component.html